import SOCIAL_LINKS from "config/socials";
import type { LanguageCode } from "config/languages";
import { getParentLanguage } from "../localeUtils";

const twitterUrl = "https://twitter.com/";

const buildTwitterUsername = (url: string) => url.replace(twitterUrl, "@");

const getSocials = (language: LanguageCode) => {
  const socialLinks = SOCIAL_LINKS[language] ? SOCIAL_LINKS[language] : SOCIAL_LINKS[getParentLanguage(language)];

  if (!socialLinks) return SOCIAL_LINKS.fallback;

  return socialLinks;
};

export const getTwitterUsername = (language: LanguageCode) => buildTwitterUsername(getSocials(language).twitter.url);

export const getSocialLink = (language: LanguageCode, socialPlatform: string): string =>
  getSocials(language)[socialPlatform].url;
